<template>
    <div class="recommended-container">
        <div class="recommended-container__image">
            <div class="recommended-container__image-badge" v-if="product?.badge" :class="product?.badge === 2 ? 'dlc' : ''">
                <div class="recommended-container__image-badge-text">
                    <svg  v-if="product?.badge === 1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.0328 7.33143C12.7295 6.64871 12.2885 6.03593 11.7375 5.53143L11.2828 5.11424C11.2674 5.10046 11.2488 5.09069 11.2287 5.08577C11.2086 5.08085 11.1876 5.08094 11.1675 5.08603C11.1475 5.09112 11.129 5.10106 11.1137 5.11497C11.0984 5.12887 11.0867 5.14633 11.0797 5.1658L10.8766 5.74861C10.75 6.11424 10.5172 6.48768 10.1875 6.85487C10.1656 6.8783 10.1406 6.88455 10.1234 6.88612C10.1063 6.88768 10.0797 6.88455 10.0562 6.86268C10.0344 6.84393 10.0234 6.8158 10.025 6.78768C10.0828 5.84705 9.80156 4.78611 9.18594 3.63143C8.67656 2.67205 7.96875 1.92361 7.08437 1.40174L6.43906 1.02205C6.35469 0.972052 6.24688 1.03768 6.25156 1.13611L6.28594 1.88611C6.30937 2.39861 6.25 2.85174 6.10938 3.2283C5.9375 3.68924 5.69062 4.11736 5.375 4.50174C5.15535 4.76887 4.9064 5.01049 4.63281 5.22205C3.97391 5.72856 3.43815 6.37757 3.06562 7.12049C2.69402 7.86989 2.50045 8.69496 2.5 9.53143C2.5 10.2689 2.64531 10.983 2.93281 11.6564C3.21042 12.3048 3.61103 12.8933 4.1125 13.3892C4.61875 13.8892 5.20625 14.283 5.86094 14.5564C6.53906 14.8408 7.25781 14.9846 8 14.9846C8.74219 14.9846 9.46094 14.8408 10.1391 14.558C10.7921 14.2862 11.386 13.8897 11.8875 13.3908C12.3938 12.8908 12.7906 12.3064 13.0672 11.658C13.3543 10.9864 13.5015 10.2634 13.5 9.53299C13.5 8.77049 13.3438 8.02987 13.0328 7.33143Z" fill="#FCE9A7"/>
                    </svg>
                    <svg v-else-if="product?.badge === 2" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.82605 1.5H2.08675C1.76314 1.5 1.5 1.76335 1.5 2.08695V4.82605C1.5 5.14966 1.76335 5.41299 2.08695 5.41299H4.82605C5.14966 5.41299 5.41299 5.14964 5.41299 4.82605V2.08695C5.41301 1.76335 5.14966 1.5 4.82605 1.5Z" fill="#92E5FF"/>
                        <path d="M9.91197 1.5H7.17288C6.84927 1.5 6.58594 1.76335 6.58594 2.08695V4.82605C6.58594 5.14966 6.84929 5.41299 7.17288 5.41299H9.91197C10.2356 5.41299 10.4989 5.14964 10.4989 4.82605V2.08695C10.4989 1.76335 10.2356 1.5 9.91197 1.5Z" fill="#92E5FF"/>
                        <path d="M4.82605 6.58691H2.08675C1.76314 6.58691 1.5 6.85027 1.5 7.17388V9.91298C1.5 10.2366 1.76335 10.4999 2.08695 10.4999H4.82605C5.14966 10.4999 5.41299 10.2366 5.41299 9.91298V7.17388C5.41301 6.85027 5.14966 6.58691 4.82605 6.58691Z" fill="#92E5FF"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.45364 10.4991C9.5833 10.4991 10.4991 9.5833 10.4991 8.45364C10.4991 7.32398 9.5833 6.4082 8.45364 6.4082C7.32398 6.4082 6.4082 7.32398 6.4082 8.45364C6.4082 9.5833 7.32398 10.4991 8.45364 10.4991Z" fill="#92E5FF"/>
                    </svg>
                    <span>{{ product?.badge === 1 ? $t('Pre-order') : 'DLC' }}</span>
                </div>
                <div class="recommended-container__image-badge-date" v-if="product?.badge === 1">
                    {{ getReleaseDate(product.additional_data.release_date) }}
                </div>
            </div>
            <div class="recommended-container__image-mask">
                <img :src="productSettings.images.icon_1200x600.src" :alt="productSettings.images.icon_1200x600.alt">
            </div>
        </div>
        <div class="recommended-container__wrap-info">
            <div class="recommended-container__info empty" v-if="isEmptyState">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M31.9998 1.86426C15.801 1.86426 2.6665 14.9988 2.6665 31.1976C2.6665 47.3964 15.801 60.5309 31.9998 60.5309C48.1987 60.5309 61.3332 47.3964 61.3332 31.1976C61.3332 14.9988 48.1987 1.86426 31.9998 1.86426ZM31.9998 55.5547C18.551 55.5547 7.64269 44.6464 7.64269 31.1976C7.64269 25.3702 9.6921 20.0143 13.11 15.8238L47.3736 50.0875C43.1832 53.5053 37.8272 55.5547 31.9998 55.5547ZM50.8897 46.5714L16.626 12.3077C20.8165 8.88985 26.1725 6.84045 31.9998 6.84045C45.4487 6.84045 56.357 17.7488 56.357 31.1976C56.357 37.025 54.3076 42.3809 50.8897 46.5714Z" fill="#F43232"/>
                </svg>
                <h4>{{ $t('Product out of stock', { ns: 'product' }) }}</h4>
                <p v-html="translatedEmpty"></p>
            </div>
            <div class="recommended-container__info" v-else>
                <div class="recommended-container__header" :class="productSettings.is_online_game ? 'online-game' : 'game'">
                    <div class="recommended-container__header-seller">
                        <OfferSellerInfo :offer="headOffer" :seller="isHeadOfferLoad ? headOffer.user : {}" :elClass="'head'" />
                        <OfferSellerTooltip :offer="headOffer" :seller="headOffer?.user ? headOffer.user : {}" />
                    </div>
                    <div class="recommended-container__tooltip-tablet" :class="{show: activeOfferTooltipId === headOffer.id}" v-if="isHeadOfferLoad && tablet">
                        <div class="recommended-container__tooltip-tablet-btn" @click="toggleTooltipOffer(headOffer.id)">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12ZM10 6C10 6.53043 10.2107 7.03914 10.5858 7.41421C10.9609 7.78929 11.4696 8 12 8C12.5304 8 13.0391 7.78929 13.4142 7.41421C13.7893 7.03914 14 6.53043 14 6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4C11.4696 4 10.9609 4.21071 10.5858 4.58579C10.2107 4.96086 10 5.46957 10 6ZM10 18C10 18.5304 10.2107 19.0391 10.5858 19.4142C10.9609 19.7893 11.4696 20 12 20C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0391 14 18.5304 14 18C14 17.4696 13.7893 16.9609 13.4142 16.5858C13.0391 16.2107 12.5304 16 12 16C11.4696 16 10.9609 16.2107 10.5858 16.5858C10.2107 16.9609 10 17.4696 10 18Z" fill="#9D9D9D"/>
                            </svg>
                        </div>
                        <div class="recommended-container__tooltip-tablet-body" :class="{active: activeOfferTooltipId === headOffer.id}">
                            <OfferDetailsModal @update-cart="forwardUpdateCart" :offer="headOffer" :isOnlineGame="productSettings.is_online_game" :tooltip="true"/>
                            <Bookmark v-if="isHeadOfferLoad && user" :requestId="headOffer.id" :is_bookmark="headOffer.is_bookmark" :request="'offer_id'"
                                @update:bookmark="({ id, newStatus }) => $emit('update:bookmark', { id, newStatus })" :title="true"/>
                            <SocialOfferInfo ref="socialOfferInfo" :offerId="headOffer.id" :clickable="true"/>
                        </div>
                    </div>
                    <div class="recommended-container__header-control" v-else>
                        <OfferDetailsModal v-if="isHeadOfferLoad" @update-cart="forwardUpdateCart" :offer="headOffer" :isOnlineGame="productSettings.is_online_game" :isHead="true"/>
                        <span class="placeholder" v-else></span>
                        <SocialOfferInfo :offerId="headOffer.id" v-if="isHeadOfferLoad"/>
                        <span class="placeholder" v-else></span>
                        <Bookmark v-if="user && isHeadOfferLoad" :requestId="headOffer.id" :is_bookmark="headOffer.is_bookmark" :request="'offer_id'"
                            @update:bookmark="({ id, newStatus }) => $emit('update:bookmark', { id, newStatus })" :title="false"/>
                        <span class="placeholder" v-else-if="user"></span>
                    </div>
                </div>
                <div class="recommended-container__body" :class="productSettings.is_online_game ? 'online-game' : 'game'">
                    <div class="recommended-container__body-info" :class="productSettings.is_online_game ? 'online-game' : 'game'" v-if="bigDesktop">
                        <div class="flex-row" :class="productSettings.is_online_game ? 'online-game' : 'game'">
                            <div class="flex-column">
                                <span class="flex-item placeholder" v-if="!isHeadOfferLoad"></span>
                                <div class="flex-item title" v-else-if="productSettings.is_online_game && headOffer?.additional_data?.game_server">
                                    <img src="/img/pages/product/icons/server.svg" alt="server">
                                    {{ $t('Server') }}:
                                </div>
                                <div class="flex-item title" v-else-if="headOffer?.offer_type">
                                    <img src="/img/pages/product/icons/key-gray.svg" alt="server">
                                    {{ $t('Product type') }}:
                                </div>
                                <span class="flex-item placeholder" v-if="!isHeadOfferLoad"></span>
                                <div class="flex-item title" v-else-if="productSettings.is_online_game && headOffer?.additional_data?.game_fraction">
                                    <img src="/img/pages/product/icons/faction.svg" alt="faction">
                                    {{ $t('Faction') }}:
                                </div>
                                <div v-else-if="headOffer?.game_marketplace" class="flex-item title">
                                    <img src="/img/pages/product/icons/platform.svg" alt="platform">
                                    {{ $t('Platform') }}:
                                </div>
                            </div>
                            <div class="flex-column">
                                <span class="flex-item placeholder" v-if="!isHeadOfferLoad"></span>
                                <div class="flex-item" v-else-if="productSettings.is_online_game && headOffer?.additional_data?.game_server">
                                    {{ capitalizeText(headOffer.additional_data.game_server) }}
                                </div>
                                <div class="flex-item" v-else-if="headOffer?.offer_type">
                                    {{ headOffer.is_steam_gift ? 'Steam Gift' : capitalizeText(headOffer.offer_type.name) }}
                                </div>
                                <span class="flex-item placeholder" v-if="!isHeadOfferLoad"></span>
                                <div class="flex-item" v-else-if="productSettings.is_online_game && headOffer?.additional_data?.game_fraction">
                                    {{ capitalizeText(headOffer.additional_data.game_fraction) }}
                                </div>
                                <div class="flex-item" v-else-if="headOffer?.game_marketplace" >
                                    {{ capitalizeText(headOffer.game_marketplace.name) }}
                                </div>
                            </div>
                        </div>
                        <div class="flex-row" :class="productSettings.is_online_game ? 'online-game' : 'game'">
                            <div class="flex-column">
                                <span class="flex-item placeholder" v-if="!isHeadOfferLoad"></span>
                                <div class="flex-item title" v-else-if="productSettings.is_online_game">
                                    <img src="/img/pages/product/icons/box.svg" alt="box">
                                    {{ $t('Min amount') }}:
                                </div>
                                <div v-else-if="headOffer?.game_edition" class="flex-item title">
                                    <img src="/img/pages/product/icons/edition.svg" alt="edition">
                                    {{ $t('Edition') }}:
                                </div>
                                <span class="flex-item placeholder" v-if="!isHeadOfferLoad"></span>
                                <div v-else-if="headOffer?.delivery_time_title" class="flex-item title">
                                    <img src="/img/pages/product/icons/delivery.svg" alt="delivery">
                                    {{ $t('Delivery') }}:
                                </div>
                            </div>
                            <div class="flex-column">
                                <span class="flex-item placeholder" v-if="!isHeadOfferLoad"></span>
                                <div class="flex-item" v-else-if="productSettings.is_online_game">
                                    {{ headOffer.min_order_quantity + productData?.currency_unit ? productData.currency_unit : '' + ' ' + productData?.game_currency }}
                                </div>
                                <div class="flex-item" v-else-if="headOffer?.game_edition">
                                    {{ capitalizeText(headOffer.game_edition?.name) }}
                                </div>
                                <span class="flex-item placeholder" v-if="!isHeadOfferLoad"></span>
                                <div v-else-if="headOffer?.delivery_time_title" class="flex-item">
                                    {{ capitalizeText(headOffer.delivery_time_title) }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="recommended-container__body-info" :class="productSettings.is_online_game ? 'online-game' : 'game'" v-else>
                        <div v-if="headOffer?.game_edition && !productSettings.is_online_game && !desktop1640" class="editon">
                            <span class="info-text">{{ $t('Edition') }}:</span>
                            <span class="info-value">{{headOffer.game_edition.name}}</span>
                        </div>
                        <span class="placeholder text editon" v-else-if="!productSettings.is_online_game && !desktop1640 && !tablet"></span>
                        <span class="line editon" v-if="!productSettings.is_online_game && !desktop1640"></span>
                        <div class="online-info" v-if="productSettings.is_online_game">
                            <span v-if="!isHeadOfferLoad"><span class="placeholder"></span></span>
                            <span v-else-if="headOffer?.additional_data?.game_server">{{ capitalizeText(headOffer.additional_data.game_server) }}</span>
                            <span v-if="!isHeadOfferLoad"><span class="placeholder"></span></span>
                            <span v-else-if="headOffer?.additional_data?.game_fraction && isHeadOfferLoad">{{ capitalizeText(headOffer.additional_data.game_fraction) }}</span>
                            <span v-if="!isHeadOfferLoad"><span class="placeholder"></span></span>
                            <span v-else-if="!tablet && isHeadOfferLoad">{{`${headOffer.min_order_quantity} ${productData?.currency_unit ? productData.currency_unit : ''} ${productData?.game_currency}`}}</span>
                        </div>
                        <OfferIconsInfo v-else-if="!tablet" :head="true" :offer="isHeadOfferLoad ? headOffer : {}" :showRegion="false" :showEdition="true"/>
                    </div>
                    <div v-if="productSettings.is_online_game" class="recommended-container__body-tooltip online-game">
                        <OfferTooltipInfo :offer="headOffer" :isOnlineGame="true"/>
                    </div>
                    <div v-else class="recommended-container__body-tooltip game">
                        <div class="region-row" v-if="bigDesktop">
                            <div class="region-column">
                                <RegionOffer type="simple" :typeIcon="1" :offer="isHeadOfferLoad ? headOffer : {}" :isHead="true"/>
                            </div>
    
                            <div class="region-column">
                                <div class="region-info w-100">
                                    <RegionOffer :typeIcon="1" :offer="isHeadOfferLoad ? headOffer : {}" :isHead="true"/>
                                </div>
                                <OfferTooltipInfo :offer="headOffer"/>
                            </div>
                        </div>
                        <div class="region-row" v-else>
                            <div class="region-column w-100">
                                <div class="region-info w-100">
                                    <RegionOffer type="folded" :typeIcon="1" :offer="isHeadOfferLoad ? headOffer : {}" :isHead="true"/>
                                </div>
                                <OfferTooltipInfo :offer="headOffer"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="recommended-container__price" v-if="tablet">
                    <div class="recommended-container__price-title" v-if="!productSettings.is_online_game">
                        <span class="recommended-container__price-title-line"></span>
                        <span class="recommended-container__price-title-text">{{ $t('Price') }}</span>
                        <span class="recommended-container__price-title-line"></span>
                    </div>
                    <div class="recommended-container__price-tablet">
                        <div class="recommended-container__price-amount stock" v-if="productSettings.is_online_game">
                            <div class="recommended-container__price-amount-title" v-html="`${$t('In Stock')} (<b>K</b> ${productData.game_currency})`"></div>
                            <div class="recommended-container__price-amount-value" v-if="isHeadOfferLoad">{{formatCurrency(headOffer.stock, productData?.currency_unit, true)}}</div>
                        </div>
                        <!-- <div class="recommended-container__price-tablet-price" v-else-if="headOffer?.id">
                            {{formatCurrency(headOffer.offer_price.price, headOffer.offer_price.currency.symbol)}}
                        </div> -->
                        <div class="recommended-container__price-tablet-price" 
                            :class="{
                                'discount-offer': headOffer?.coupon
                            }" v-else-if="isHeadOfferLoad">
                            <template v-if="headOffer?.coupon">
                                <div class="discount-offer__percent" @click.stop="copyToClipboard(headOffer.coupon.code)">
                                    <span class="discount-offer__percent-bold">{{ '-'+headOffer.coupon.value+ '%' }}</span>
                                </div>
                                <span class="discount-offer__new-price">{{formatCouponePrice(headOffer.offer_price.price, headOffer.offer_price.currency.symbol, headOffer.coupon.value, headOffer.min_order_quantity)}}</span>
                            </template>
                            <template v-else>
                                {{formatCurrency(headOffer.offer_price.price, headOffer.offer_price.currency.symbol, false, headOffer.min_order_quantity)}}
                            </template>
                        </div>
                        <span class="line"></span>
                            <div class="recommended-container__price-amount online-game" v-if="productSettings.is_online_game && isHeadOfferLoad">
                                <div class="recommended-container__price-amount-title online-game" v-html="`${$t('Price in')} <b>${headOffer?.offer_price.currency.symbol}</b> / ${headOffer?.min_order_quantity} <b>${productData?.currency_unit ? productData?.currency_unit : ''}</b> ${productData?.game_currency}`"></div>
                                <div class="recommended-container__price-amount-value" :class="{
                                        'online-game': productSettings.is_online_game,
                                        'game': !productSettings.is_online_game,
                                        'discount-offer': headOffer?.coupon
                                    }" v-if="isHeadOfferLoad">
                                    <template v-if="headOffer?.coupon">
                                        <div class="discount-offer__percent" @click.stop="copyToClipboard(headOffer.coupon.code)">
                                            <span class="discount-offer__percent-bold">{{ '-'+headOffer.coupon.value+ '%' }}</span>
                                        </div>
                                        <span class="discount-offer__new-price">{{formatCouponePrice(headOffer.offer_price.price, headOffer.offer_price.currency.symbol, headOffer.coupon.value, headOffer.min_order_quantity)}}</span>
                                    </template>
                                    <template v-else>
                                        {{formatCurrency(headOffer.offer_price.price, headOffer.offer_price.currency.symbol, false, headOffer.min_order_quantity)}}
                                    </template>
                                </div>
                                <div class="recommended-container__price-amount-value placeholder" v-else-if="!tablet"></div>
                            </div>
                            <OfferIconsInfo v-else :head="true" :offer="headOffer" :showEdition="true"/>
                        <span class="line"></span>
                        <button class="btn btn__add-to-cart" v-if="isHeadOfferLoad && headOffer.user.id === user?.id"
                            @click="redirectToOffer(headOffer.id)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M20.71 7.04055C21.1 6.65055 21.1 6.00055 20.71 5.63055L18.37 3.29055C18 2.90055 17.35 2.90055 16.96 3.29055L15.12 5.12055L18.87 8.87055M3 17.2506V21.0006H6.75L17.81 9.93055L14.06 6.18055L3 17.2506Z" fill="#fff"/>
                            </svg>
                        </button>
                        <template v-else-if="isHeadOfferLoad">
                            <button class="btn" :class="headOffer.is_added_to_cart ? 'btn__remove-from-cart' : 'btn__add-to-cart'"
                                @click="addRemoveOfferToCart(headOffer?.id, !headOffer.is_added_to_cart)">
                                <svg v-if="headOffer.is_added_to_cart" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M25.2772 12.1923L24.8571 25.1922C24.8213 26.3055 24.3626 27.3608 23.5784 28.1341C22.7941 28.9073 21.746 29.3376 20.6565 29.3336H12.6754C11.5867 29.3376 10.5392 28.9079 9.75503 28.1356C8.97087 27.3633 8.5117 26.3091 8.47485 25.1965L8.05479 12.1923C8.0456 11.9075 8.14743 11.6306 8.33787 11.4226C8.52831 11.2146 8.79177 11.0925 9.07028 11.0831C9.3488 11.0737 9.61956 11.1778 9.823 11.3725C10.0264 11.5672 10.1459 11.8366 10.1551 12.1214L10.5751 25.1245C10.5961 25.6796 10.8265 26.2048 11.2182 26.5899C11.6098 26.9749 12.1321 27.1898 12.6754 27.1894H20.6565C21.2005 27.1897 21.7234 26.9743 22.1152 26.5883C22.5069 26.2024 22.737 25.6761 22.7568 25.1202L23.1769 12.1214C23.1861 11.8366 23.3055 11.5672 23.509 11.3725C23.7124 11.1778 23.9832 11.0737 24.2617 11.0831C24.5402 11.0925 24.8036 11.2146 24.9941 11.4226C25.1845 11.6306 25.2864 11.9075 25.2772 12.1923ZM26.6665 7.86611C26.6665 8.15089 26.5559 8.424 26.3589 8.62537C26.162 8.82674 25.8949 8.93986 25.6164 8.93986H7.71665C7.43813 8.93986 7.17102 8.82674 6.97408 8.62537C6.77714 8.424 6.6665 8.15089 6.6665 7.86611C6.6665 7.58133 6.77714 7.30822 6.97408 7.10685C7.17102 6.90549 7.43813 6.79236 7.71665 6.79236H10.9721C11.3048 6.79327 11.626 6.66758 11.8731 6.43973C12.1202 6.21189 12.2756 5.89819 12.3089 5.55969C12.3864 4.76564 12.7503 4.02952 13.3296 3.49477C13.9089 2.96001 14.6621 2.66493 15.4426 2.667H17.8894C18.6698 2.66493 19.4231 2.96001 20.0024 3.49477C20.5817 4.02952 20.9455 4.76564 21.023 5.55969C21.0564 5.89819 21.2118 6.21189 21.4589 6.43973C21.706 6.66758 22.0271 6.79327 22.3599 6.79236H25.6153C25.8938 6.79236 26.1609 6.90549 26.3579 7.10685C26.5548 7.30822 26.6655 7.58133 26.6655 7.86611H26.6665ZM14.132 6.79236H19.2021C19.0641 6.46996 18.9738 6.12833 18.9343 5.77874C18.9083 5.51407 18.7871 5.26869 18.5943 5.09015C18.4014 4.91161 18.1506 4.81262 17.8904 4.81236H15.4436C15.1835 4.81262 14.9327 4.91161 14.7398 5.09015C14.547 5.26869 14.4258 5.51407 14.3998 5.77874C14.3599 6.12839 14.2703 6.47001 14.132 6.79236ZM15.1895 23.0608V13.9178C15.1895 13.633 15.0788 13.3599 14.8819 13.1585C14.685 12.9572 14.4178 12.844 14.1393 12.844C13.8608 12.844 13.5937 12.9572 13.3968 13.1585C13.1998 13.3599 13.0892 13.633 13.0892 13.9178V23.0651C13.0892 23.3498 13.1998 23.623 13.3968 23.8243C13.5937 24.0257 13.8608 24.1388 14.1393 24.1388C14.4178 24.1388 14.685 24.0257 14.8819 23.8243C15.0788 23.623 15.1895 23.3498 15.1895 23.0651V23.0608ZM20.2449 23.0608V13.9178C20.2449 13.633 20.1342 13.3599 19.9373 13.1585C19.7403 12.9572 19.4732 12.844 19.1947 12.844C18.9162 12.844 18.6491 12.9572 18.4522 13.1585C18.2552 13.3599 18.1446 13.633 18.1446 13.9178V23.0651C18.1446 23.3498 18.2552 23.623 18.4522 23.8243C18.6491 24.0257 18.9162 24.1388 19.1947 24.1388C19.4732 24.1388 19.7403 24.0257 19.9373 23.8243C20.1342 23.623 20.2449 23.3498 20.2449 23.0651V23.0608Z" fill="white"/>
                                </svg>
                                <svg v-else width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.8023 22.225C24.8023 22.6039 24.5001 22.9015 24.1157 22.9015H10.9767C9.83663 22.9015 8.9165 21.995 8.9165 20.8722C8.9165 19.8441 9.68554 18.9916 10.7019 18.8699C10.7843 18.8428 10.8805 18.8428 10.9767 18.8428C11.1414 18.8428 11.3062 18.9106 11.4162 19.0187L11.004 20.1958C10.9904 20.1958 10.9904 20.1958 10.9767 20.1958C10.5921 20.1958 10.2899 20.4933 10.2899 20.8722C10.2899 21.251 10.5921 21.5487 10.9767 21.5487H24.1157C24.5001 21.5487 24.8023 21.8462 24.8023 22.225Z" fill="white"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.55735 9.37431C8.60098 9.42838 9.34051 9.75739 10.085 10.0795C10.0877 10.0212 10.0952 9.96347 10.0818 9.90393L9.47765 7.19803C9.40845 6.88751 9.12952 6.66699 8.80696 6.66699H4.68678C4.30718 6.66699 4 6.96959 4 7.34351C4 7.71726 4.30718 8.01986 4.68678 8.01986H8.25499L8.55735 9.37431Z" fill="white"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.8027 22.2252C24.8027 22.604 24.5005 22.9017 24.1161 22.9017H17.6562V21.5488H24.1161C24.5005 21.5488 24.8027 21.8463 24.8027 22.2252Z" fill="white"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M27.3028 9.64376C27.1655 9.46781 26.9731 9.37305 26.7533 9.37305H8.56006L10.7027 18.8704L11.0048 20.1963H24.0066C24.3087 20.1963 24.5834 19.9932 24.6658 19.7091L27.4126 10.2389C27.4677 10.036 27.4264 9.80598 27.3028 9.64376Z" fill="white"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M27.4121 10.2389L24.6654 19.7091C24.5829 19.9932 24.3083 20.1963 24.0061 20.1963H17.6562V9.37305H26.7529C26.9726 9.37305 27.165 9.46781 27.3023 9.64376C27.4259 9.80598 27.4672 10.036 27.4121 10.2389Z" fill="white"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3402 25.3342C12.4317 25.3342 11.6929 24.6063 11.6929 23.7115C11.6929 22.8167 12.4317 22.0889 13.3402 22.0889C14.2485 22.0889 14.9873 22.8167 14.9873 23.7115C14.9873 24.6063 14.2485 25.3342 13.3402 25.3342Z" fill="white"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.3949 25.3342C20.4866 25.3342 19.7476 24.6063 19.7476 23.7115C19.7476 22.8167 20.4866 22.0889 21.3949 22.0889C22.3031 22.0889 23.0422 22.8167 23.0422 23.7115C23.0422 24.6063 22.3031 25.3342 21.3949 25.3342Z" fill="white"/>
                                </svg>
                            </button>
                        </template>
                        <span v-else class="placeholder"></span>
                    </div>
                </div>
                <div class="recommended-container__price" v-else>
                    <div class="recommended-container__price-title" v-if="!productSettings.is_online_game">
                        <span class="recommended-container__price-title-line"></span>
                        <span class="recommended-container__price-title-text">{{ $t('Price') }}</span>
                        <span class="recommended-container__price-title-line"></span>
                    </div>
                    <div class="recommended-container__price-amount" :class="productSettings.is_online_game ? 'online-game' : 'game'">
                        <div class="recommended-container__price-amount-title" v-if="isHeadOfferLoad" 
                            :class="{
                                'online-game': productSettings.is_online_game,
                                'game': !productSettings.is_online_game,
                                'discount-offer': headOffer?.coupon
                            }"
                            v-html="productSettings.is_online_game ? `${$t('Price in')} <b>${headOffer?.offer_price.currency.symbol}</b> / ${headOffer?.min_order_quantity} <b>${productData?.currency_unit ? productData?.currency_unit : ''}</b> ${productData?.game_currency}` : `${$t('Total amount')}:`"></div>
                        <div class="recommended-container__price-amount-title placeholder" v-else-if="!tablet"></div>
                        <div class="recommended-container__price-amount-value" 
                            :class="{
                                'online-game': productSettings.is_online_game,
                                'game': !productSettings.is_online_game,
                                'discount-offer': headOffer?.coupon
                            }" v-if="isHeadOfferLoad">
                            <template v-if="headOffer?.coupon">
                                <div class="discount-offer__percent" @click.stop="copyToClipboard(headOffer.coupon.code)">
                                    <span class="discount-offer__percent-bold">{{ '-'+headOffer.coupon.value+ '%' }}</span>
                                    <!-- <div class="discount-offer__percent-code">
                                        <span>{{ headOffer.coupon.code }}</span>
                                        <img class="copy-button" src="/img/pages/product/icons/copy-green.svg" alt="copy">
                                    </div> -->
                                </div>
                                <span class="discount-offer__old-price">{{formatCurrency(headOffer.offer_price.price, headOffer.offer_price.currency.symbol, false, headOffer.min_order_quantity)}}</span>
                                <span class="discount-offer__new-price">{{formatCouponePrice(headOffer.offer_price.price, headOffer.offer_price.currency.symbol, headOffer.coupon.value, headOffer.min_order_quantity)}}</span>
                            </template>
                            <template v-else>
                                <span>{{formatCurrency(headOffer.offer_price.price, headOffer.offer_price.currency.symbol, false, headOffer.min_order_quantity)}}</span>
                            </template>
                            <PayButtons v-if="product.payment_methods.length" :paymentMethods="product.payment_methods" @pay="goToCheckout($event)"/>
                        </div>
                        <div class="recommended-container__price-amount-value placeholder" v-else-if="!tablet"></div>
                        <PayButtons v-if="false && !productSettings.is_online_game && product.payment_methods.length" :paymentMethods="product.payment_methods" @pay="goToCheckout($event)"/>
                    </div>
                    <div class="recommended-container__price-amount stock" v-if="productSettings.is_online_game">
                        <div class="recommended-container__price-amount-title" v-html="`${$t('In Stock')} (<b>${productData?.currency_unit ? productData?.currency_unit : ''}</b> ${productData?.game_currency})`"></div>
                        <div class="recommended-container__price-amount-value" v-if="isHeadOfferLoad">{{formatCurrency(headOffer.stock, productData?.currency_unit, true)}}</div>
                        <div class="recommended-container__price-amount-value placeholder" v-else-if="!tablet"></div>
                    </div>
                    <div class="recommended-container__price-btn">
                        <button class="btn btn__add-to-card" v-if="isHeadOfferLoad && headOffer.user.id === user?.id"
                            @click="redirectToOffer(headOffer.id)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M20.71 7.04055C21.1 6.65055 21.1 6.00055 20.71 5.63055L18.37 3.29055C18 2.90055 17.35 2.90055 16.96 3.29055L15.12 5.12055L18.87 8.87055M3 17.2506V21.0006H6.75L17.81 9.93055L14.06 6.18055L3 17.2506Z" fill="#F75A01"/>
                            </svg>
                            <span>
                                {{ $t('Edit') }} 
                            </span>
                        </button>
                        <template v-else-if="isHeadOfferLoad" >
                            <button 
                                class="btn btn__add-to-card"
                                :class="{
                                    remove: headOffer.is_added_to_cart,
                                    add: !headOffer.is_added_to_cart,
                                    online: productSettings.is_online_game,
                                    preload: loadBtn
                                }"
                                @click="addRemoveOfferToCart(headOffer.id, !headOffer.is_added_to_cart)">
                                <svg v-if="headOffer.is_added_to_cart" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.958 9.14395L18.6429 18.8939C18.6161 19.7289 18.2721 20.5204 17.6839 21.1003C17.0957 21.6802 16.3096 22.0029 15.4925 22H9.50669C8.69012 22.003 7.90451 21.6807 7.31639 21.1015C6.72828 20.5222 6.3839 19.7316 6.35626 18.8971L6.04122 9.14395C6.03432 8.93037 6.11069 8.72273 6.25353 8.56672C6.39636 8.41071 6.59395 8.31911 6.80284 8.31206C7.01172 8.30501 7.21479 8.3831 7.36737 8.52914C7.51995 8.67518 7.60954 8.87721 7.61643 9.0908L7.93148 18.8431C7.94717 19.2595 8.12003 19.6534 8.41375 19.9422C8.70748 20.2309 9.09922 20.3921 9.50669 20.3918H15.4925C15.9005 20.392 16.2927 20.2304 16.5865 19.941C16.8803 19.6515 17.0528 19.2568 17.0677 18.8399L17.3828 9.0908C17.3897 8.87721 17.4793 8.67518 17.6318 8.52914C17.7844 8.3831 17.9875 8.30501 18.1964 8.31206C18.4053 8.31911 18.6029 8.41071 18.7457 8.56672C18.8885 8.72273 18.9649 8.93037 18.958 9.14395ZM20 5.89934C20 6.11292 19.917 6.31776 19.7693 6.46878C19.6216 6.61981 19.4213 6.70465 19.2124 6.70465H5.78761C5.57872 6.70465 5.37839 6.61981 5.23068 6.46878C5.08298 6.31776 5 6.11292 5 5.89934C5 5.68576 5.08298 5.48092 5.23068 5.3299C5.37839 5.17887 5.57872 5.09402 5.78761 5.09402H8.22919C8.47875 5.09471 8.71962 5.00044 8.90495 4.82956C9.09027 4.65867 9.20679 4.4234 9.23182 4.16952C9.28994 3.57398 9.56282 3.0219 9.99729 2.62083C10.4318 2.21977 10.9967 1.99845 11.582 2.00001H13.4172C14.0025 1.99845 14.5674 2.21977 15.0019 2.62083C15.4364 3.0219 15.7093 3.57398 15.7674 4.16952C15.7924 4.4234 15.9089 4.65867 16.0943 4.82956C16.2796 5.00044 16.5205 5.09471 16.77 5.09402H19.2116C19.4205 5.09402 19.6208 5.17887 19.7685 5.3299C19.9162 5.48092 19.9992 5.68576 19.9992 5.89934H20ZM10.5991 5.09402H14.4017C14.2982 4.85222 14.2305 4.59601 14.2008 4.33381C14.1813 4.1353 14.0904 3.95127 13.9458 3.81737C13.8012 3.68347 13.6131 3.60922 13.418 3.60903H11.5828C11.3877 3.60922 11.1996 3.68347 11.055 3.81737C10.9103 3.95127 10.8195 4.1353 10.7999 4.33381C10.77 4.59605 10.7029 4.85227 10.5991 5.09402ZM11.3922 17.2953V10.4381C11.3922 10.2245 11.3092 10.0197 11.1615 9.86864C11.0138 9.71762 10.8135 9.63277 10.6046 9.63277C10.3957 9.63277 10.1954 9.71762 10.0477 9.86864C9.89999 10.0197 9.81701 10.2245 9.81701 10.4381V17.2986C9.81701 17.5121 9.89999 17.717 10.0477 17.868C10.1954 18.019 10.3957 18.1039 10.6046 18.1039C10.8135 18.1039 11.0138 18.019 11.1615 17.868C11.3092 17.717 11.3922 17.5121 11.3922 17.2986V17.2953ZM15.1838 17.2953V10.4381C15.1838 10.2245 15.1008 10.0197 14.9531 9.86864C14.8054 9.71762 14.6051 9.63277 14.3962 9.63277C14.1873 9.63277 13.9869 9.71762 13.8392 9.86864C13.6915 10.0197 13.6086 10.2245 13.6086 10.4381V17.2986C13.6086 17.5121 13.6915 17.717 13.8392 17.868C13.9869 18.019 14.1873 18.1039 14.3962 18.1039C14.6051 18.1039 14.8054 18.019 14.9531 17.868C15.1008 17.717 15.1838 17.5121 15.1838 17.2986V17.2953Z" fill="#F43232"/>
                                </svg>
                                <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.6019 16.6685C18.6019 16.9527 18.3752 17.1759 18.0869 17.1759H8.23263C7.37759 17.1759 6.6875 16.496 6.6875 15.6539C6.6875 14.8828 7.26428 14.2435 8.02652 14.1522C8.08834 14.1318 8.16048 14.1318 8.23263 14.1318C8.35614 14.1318 8.47978 14.1827 8.56226 14.2638L8.25315 15.1466C8.24296 15.1466 8.24296 15.1466 8.23263 15.1466C7.94418 15.1466 7.71754 15.3697 7.71754 15.6539C7.71754 15.938 7.94418 16.1613 8.23263 16.1613H18.0869C18.3752 16.1613 18.6019 16.3844 18.6019 16.6685Z" fill="#F75A01"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.41801 7.03049C6.45073 7.07104 7.00538 7.3178 7.56378 7.55941C7.5658 7.51568 7.57143 7.47236 7.56137 7.42771L7.10824 5.39828C7.05634 5.16539 6.84714 5 6.60522 5H3.51509C3.23039 5 3 5.22695 3 5.50739C3 5.7877 3.23039 6.01465 3.51509 6.01465H6.19124L6.41801 7.03049Z" fill="#F75A01"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.602 16.6684C18.602 16.9525 18.3754 17.1758 18.0871 17.1758H13.2422V16.1611H18.0871C18.3754 16.1611 18.602 16.3842 18.602 16.6684Z" fill="#F75A01"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.477 7.23233C20.374 7.10037 20.2297 7.0293 20.0649 7.0293H6.41992L8.02688 14.1523L8.25351 15.1467H18.0048C18.2314 15.1467 18.4374 14.9944 18.4992 14.7814L20.5593 7.67869C20.6006 7.52652 20.5696 7.35399 20.477 7.23233Z" fill="#F75A01"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5591 7.67869L18.499 14.7814C18.4372 14.9944 18.2312 15.1467 18.0046 15.1467H13.2422V7.0293H20.0647C20.2295 7.0293 20.3738 7.10037 20.4768 7.23233C20.5694 7.35399 20.6004 7.52652 20.5591 7.67869Z" fill="#F75A01"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.005 19.0004C9.32368 19.0004 8.76953 18.4544 8.76953 17.7834C8.76953 17.1123 9.32368 16.5664 10.005 16.5664C10.6862 16.5664 11.2404 17.1123 11.2404 17.7834C11.2404 18.4544 10.6862 19.0004 10.005 19.0004Z" fill="#F75A01"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.046 19.0004C15.3648 19.0004 14.8105 18.4544 14.8105 17.7834C14.8105 17.1123 15.3648 16.5664 16.046 16.5664C16.7272 16.5664 17.2815 17.1123 17.2815 17.7834C17.2815 18.4544 16.7272 19.0004 16.046 19.0004Z" fill="#F75A01"/>
                                </svg>
                                <span>{{ headOffer.is_added_to_cart ? $t('Remove from Cart') : $t('Add to Cart') }}</span>
                            </button>
                            
                            <a v-if="!productSettings.is_online_game && !headOffer?.is_own_offer" 
                                href="/checkout" 
                                class="btn btn__go-cheсkout"
                                @click.prevent="goToCheckout()"><span>{{ $t('Go to Checkout') }}</span>
                            </a>
                        </template>
                        <template v-else>
                            <button class="btn placeholder"></button>
                            <button class="btn placeholder" v-if="!productSettings.is_online_game && !headOffer?.is_own_offer"></button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="recommended-container__badge" v-if="product?.badge" :class="product?.badge === 2 ? 'dlc' : ''">
        <div class="recommended-container__badge-icon">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.25 12C8.25 11.5858 8.58579 11.25 9 11.25C9.41421 11.25 9.75 11.5858 9.75 12C9.75 12.4142 9.41421 12.75 9 12.75C8.58579 12.75 8.25 12.4142 8.25 12ZM8.25 6C8.25 5.58579 8.58579 5.25 9 5.25C9.41421 5.25 9.75 5.58579 9.75 6V9C9.75 9.41421 9.41421 9.75 9 9.75C8.58579 9.75 8.25 9.41421 8.25 9V6ZM9 1.5C4.8525 1.5 1.5 4.875 1.5 9C1.5 10.9891 2.29018 12.8968 3.6967 14.3033C4.39314 14.9997 5.21993 15.5522 6.12987 15.9291C7.03982 16.306 8.01509 16.5 9 16.5C10.9891 16.5 12.8968 15.7098 14.3033 14.3033C15.7098 12.8968 16.5 10.9891 16.5 9C16.5 8.01509 16.306 7.03982 15.9291 6.12987C15.5522 5.21993 14.9997 4.39314 14.3033 3.6967C13.6069 3.00026 12.7801 2.44781 11.8701 2.0709C10.9602 1.69399 9.98491 1.5 9 1.5ZM9 15C7.4087 15 5.88258 14.3679 4.75736 13.2426C3.63214 12.1174 3 10.5913 3 9C3 7.4087 3.63214 5.88258 4.75736 4.75736C5.88258 3.63214 7.4087 3 9 3C10.5913 3 12.1174 3.63214 13.2426 4.75736C14.3679 5.88258 15 7.4087 15 9C15 10.5913 14.3679 12.1174 13.2426 13.2426C12.1174 14.3679 10.5913 15 9 15Z" fill="#FFC700"/>
            </svg>
        </div>
        <span class="recommended-container__badge-text"
            v-html="product?.badge === 2 ? 
                $t('This product is an {dlc} to the main game, you can use it if you have the game itself.', {ns: 'product', dlc: '<span>'+ $t('Add-on', {ns: 'product'}) +'</span>'}) : 
                $t('This game is in {preorder} and will be available for Download/Installation on the day of release.', {ns: 'product', preorder: '<span>'+ $t('pre-order status', {ns: 'product'}) +'</span>'})">
        </span>
    </div>
</template>

<script>
import OfferSellerTooltip from './OfferSellerTooltip.vue';
import OfferSellerInfo from './OfferSellerInfo.vue';
import OfferIconsInfo from './OfferIconsInfo.vue';
import OfferTooltipInfo from './OfferTooltipInfo.vue';
import OfferDetailsModal from './OfferDetailsModal.vue';
import SocialOfferInfo from './SocialOfferInfo.vue';
import Bookmark from './Bookmark.vue';
import RegionOffer from './RegionOffer.vue';
import PayButtons from './PayButtons.vue';
import { renderAlertVue } from "/webpack-assets/vue/utils/common.js";

export default {
  components: {
    OfferSellerInfo,
    OfferSellerTooltip,
    OfferIconsInfo,
    OfferTooltipInfo,
    OfferDetailsModal,
    Bookmark,
    SocialOfferInfo,
    RegionOffer,
    PayButtons
  },
  emits: ['update-cart', 'update:bookmark'],
  props: {
    product: {
      type: Object,
      required: true
    },
    headOffer: {
      type: Object,
      default: null
    },
    mobile: {
      type: Boolean,
      default: false
    },
    tablet: {
      type: Boolean,
      default: false
    },
    desktop1440: {
      type: Boolean,
      default: false
    },
    desktop1640: {
        type: Boolean,
        default: false
    },
    bigDesktop: {
      type: Boolean,
      default: false
    },
    activeOfferTooltipId: {
      type: Number,
      default: null
    },
    isHeadOfferLoad: {
      type: Boolean,
      default: false
    },
    isEmptyState: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
        loadBtn: false,
        user: window.common.user || null,
        productData: window.settings.product.additional_data,
        productSettings: window.settings.product,
        language: window.common.language.code2,
    };
  },
  mounted() {

  },
  methods: {
    redirectToOffer(offerId) {
        const url = '/offer/' + offerId;
        window.open(url, '_blank').focus();
    },
    formatCurrency(amount, symbol, isOnline = false, minAmount = 1) {
        const basePrice = minAmount * amount;
        let formatted = Number(basePrice)
            .toFixed(isOnline ? 0 : 2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
            .replace(',', '.');

        if(isOnline) {
            return symbol ? `${formatted} ${symbol}` : `${formatted}`
        } else {
            return `${symbol} ${formatted}`
        }
    },
    capitalizeText(text) {
        if (!text) return '';
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },
    formatCouponePrice(amount, symbol, code, minAmount = 1) {
        const basePrice = minAmount * amount;
        const discount = (basePrice * code) / 100;
        const newPrice = basePrice - discount;
        const formatted = Number(newPrice)
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
            .replace(',', '.');
        return `${symbol} ${formatted}`
    },
    getReleaseDate(dateStr) {
        if (!dateStr) return '';

        const locale = this.language || 'en';

        const date = new Date(dateStr);
        if (isNaN(date)) return '';

        const day = String(date.getUTCDate()).padStart(2, '0');
        const monthName = new Intl.DateTimeFormat(locale, { month: 'short', timeZone: 'UTC' }).format(date);
        const year = date.getUTCFullYear();

        return `${day} ${monthName} ${year}`;
    },
    addRemoveOfferToCart(offerId, isAdd, amount = 1) {
        this.loadBtn = true;
        this.$emit('update-cart', { offerId, isAdd, amount });
        setTimeout(()=>{this.loadBtn = false},500)
    },
    forwardUpdateCart(payload) {
        this.$emit('update-cart', payload);
    },
    copyToClipboard(copyData) {
        let tempTextarea = document.createElement('textarea');
        tempTextarea.value = copyData;
        document.body.appendChild(tempTextarea);
        tempTextarea.select();
        document.execCommand('copy');
        document.body.removeChild(tempTextarea);
        renderAlertVue(this.$t('Promo code has been successfully copied.'), 'success', 2000)
    },
    goToCheckout(methodId = null) {
        let amount = this.headOffer?.min_order_quantity ? this.headOffer.min_order_quantity : 1;
        const url = `/cart/add/${this.headOffer.id}?amount=${amount}&buy_now=1`;

        const params = new URLSearchParams(window.location.search);
        const offerCoupon = this.headOffer?.coupon?.code ?? null;
        const couponParam = offerCoupon ?? params.get('coupon');
        console.log(couponParam)
        const data = couponParam ? { coupon: couponParam } : {};

        $.ajax({
            url: url,
            method: 'POST',
            data: data,
            success: () => {
                window.updateMiniCarts(amount, this.headOffer.id, false, couponParam);

                const checkoutUrl = methodId 
                    ? `/checkout?paymentMethodId=${methodId}` 
                    : '/checkout';

                this.$nextTick(() => {
                    window.location = checkoutUrl;
                });
            },
            error: (xhr, status, error) => {
                console.error('Error adding to cart:', error);
                // this.isSubmitting = false;
            }
        });
    },
  },
  computed: {
    translatedEmpty() {
      return this.$t('Unfortunately, at the moment there are no product offers, you can choose another product in our {link}', {
        link: '<a href="/product" target="_blank" rel="nofollow noopener" class="link">' + this.$t('Catalogue') + '</a>',
        ns: 'product'
      });
    },
  }
};
</script>
  
<style lang="scss" scoped>
.recommended-container {
    display: flex;
    padding-bottom: 30px;
    position: relative;
    z-index: 3;

    @media only screen and (max-width: 991px) {}

    &__badge {
        box-shadow: 3px 3px 12px 0px #0000000D;
        box-shadow: -2px -2px 8px 0px #0000000D;
        padding: 10px 15px;
        display: flex;
        align-items: center;
        gap: 15px;
        background-color: #fff;
        border-radius: 12px;
        margin: -10px 0 30px;
        background-image: url('/webpack-assets/img/product/badge-pre-order.png');
        background-size: 100% 100%;
        background-position: left;
        background-repeat: no-repeat;

        &-icon {
            box-shadow: 0px 1.5px 11.25px 0px #F0BB014D;
            background-color: #fff;
            border-radius: 50%;
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &-text {
            font-family: "Avenir-Next", sans-serif;
            color: #505050;
            font-weight: 400;
            font-size: 14px;
            line-height: 140%;

            &:deep(span) {
                font-family: "Avenir-Next-DemiBold", sans-serif;
                color: #FFC700;
            }
        }

        &.dlc {
            background-image: url('/webpack-assets/img/product/badge-dlc.png');

            .recommended-container__badge-icon {
                box-shadow: 0px 1.5px 11.25px 0px #017CF04D;

                svg {
                    path {
                        fill: #4E8AFF;
                    }
                }
            }

            .recommended-container__badge-text {
                color: #505050;

                &:deep(span) {
                    color: #4E8AFF;
                }
            }
        }
    }

    &__wrap-info {
        margin-left: -30px;
        padding-left: 90px;
        position: relative;

        @media only screen and (max-width: 1919px) {
            margin-left: -30px;
            padding-left: 70px;
        }

        @media only screen and (max-width: 1639px) {}

        @media only screen and (max-width: 1199px) {
            margin-left: -42px;
        }

        @media only screen and (max-width: 991px) {
            margin-left: -38px;
            padding-left: 60px;
        }

        &::before {
            content: '';
            position: absolute;
            height: 100%;
            left: 35px;
            top: 0;
            width: 100px;
            border-radius: 16px 0 0 16px;
            z-index: 1;
            background-color: #FFFFFF;
            transform: skew(-10.5deg);
        }
    }

    &__wrap-info,
    &__image {
        width: 100%;
        max-width: 810px;
        height: 405px;
        width: calc(50% + 15px);

        //box-shadow: 0px 4px 10px 0px #8585851A;
        @media only screen and (max-width: 1919px) {
            height: 339px;
            max-width: 672px;
        }

        @media only screen and (max-width: 1639px) {
            height: 285px;
            max-width: 585px;
        }

        @media only screen and (max-width: 1439px) {
            height: 301px;
            max-width: 602px;
        }

        @media only screen and (max-width: 1199px) {
            height: 249px;
            max-width: 497px;
            width: calc(50% + 21px);
        }

        @media only screen and (max-width: 991px) {
            height: 180px;
            max-width: 378px;
            width: calc(50% + 25px);
        }

        &-mask {
            width: 100%;
            height: 100%;
            background-size: 100%;
            background-position: center 0;
            background-repeat: no-repeat;
            mask-image: url('/webpack-assets/img/product/mask-img.webp');
            mask-repeat: no-repeat;
            mask-size: 100% 100%;
            mask-position: 0 0;
            position: relative;
            z-index: 1;
            pointer-events: none;
            border-radius: 16px;

            img {
                height: 100%;
                width: 100%;
            }
        }
    }

    &__image {
        position: relative;

        &-badge {
            z-index: 10;
            position: absolute;
            backdrop-filter: blur(8px);
            background: rgba(157, 123, 0, .4);
            border-radius: 8px;
            top: 10px;
            left: 10px;
            padding: 5px 10px;
            display: flex;
            align-items: center;

            &-text {
                display: flex;
                align-items: center;
                gap: 6px;

                span {
                    color: #FCE9A7;
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 140%;
                }
            }

            &-date {
                color: #FCE9A7;
                font-family: "Avenir-Next", sans-serif;
                font-weight: 400;
                font-size: 12px;
                line-height: 140%;
                margin-left: 10px;
                padding-left: 10px;
                border-left: 1px solid #FCE9A7;
            }

            &.dlc {
                background: #44F1FC80;

                .recommended-container__image-badge-text {
                    span {
                        color: #92E5FF;
                    }
                }
            }
        }
    }

    &__info {
        background-color: #fff;
        padding: 40px 40px 40px 0;
        border-radius: 17px 16px 16px 0;
        position: relative;
        z-index: 2;
        height: 100%;

        @media only screen and (max-width: 1919px) {
            padding: 30px 30px 30px 0;
        }

        @media only screen and (max-width: 1639px) {
            padding: 20px 20px 20px 0;
        }

        @media only screen and (max-width: 1199px) {
            padding: 15px 15px 15px 0;
        }

        @media only screen and (max-width: 991px) {
            padding: 15px 15px 10px 0;
        }

        &.empty {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            svg {
                margin-bottom: 30px;
            }

            h4 {
                font-family: "Avenir-Next-DemiBold", sans-serif;
                font-weight: 400;
                font-size: 22px;
                color: #1F1F1F;
                line-height: 140%;
                padding-bottom: 10px;
                text-align: center;

                @media only screen and (max-width: 991px) {
                    font-size: 16px;
                    padding-bottom: 0;
                }
            }

            p {
                font-family: "Avenir-Next", sans-serif;
                font-weight: 400;
                font-size: 16px;
                text-align: center;
                line-height: 24px;
                letter-spacing: 0px;
                color: #9D9D9D;

                :deep(a) {
                    color: #4E8AFF;
                }

                @media only screen and (max-width: 991px) {
                    display: none;
                }
            }
        }
    }

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;

        @media only screen and (max-width: 1919px) {
            margin-bottom: 38px;
        }

        @media only screen and (max-width: 1639px) {
            margin-bottom: 15px;

            &.game {
                margin-bottom: 23px;
            }
        }

        @media only screen and (max-width: 1439px) {
            &.game {
                margin-bottom: 30px;
            }
        }

        @media only screen and (max-width: 1199px) {
            margin-bottom: 15px;

            &.game {
                margin-bottom: 15px;
            }
        }

        @media only screen and (max-width: 991px) {
            // margin-bottom: 10px;
            // &.game{
            //     margin-bottom: 10px;
            // }
        }

        &-control {
            display: flex;
            align-items: center;
            gap: 15px;

            .placeholder {
                display: block;
                width: 20px;
                height: 20px;
                border-radius: 8px;
            }
        }

        &-seller {
            position: relative;

            &:hover {
                .seller-tooltip {
                    pointer-events: all;
                    opacity: 1;
                }
            }
        }
    }

    &__tooltip-tablet {
        position: absolute;
        top: 10px;
        right: 10px;

        &-btn {
            display: flex;
            align-items: center;

            svg {
                path {
                    transition: 0.4s;
                }
            }

            &:hover {
                svg path {
                    fill: #4E8AFF;
                }
            }

            &::before {
                content: none;
                position: absolute;
                top: 0;
                right: 0;
                width: 100px;
                height: 40px;
                background-color: transparent;
            }
        }

        &-body {
            position: absolute;
            top: 30px;
            right: 0;
            box-shadow: 0px 2px 10px 0px #00000040;
            border-radius: 16px;
            background-color: #fff;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            width: 220px;
            opacity: 0;
            pointer-events: none;
            transition: 0.4s;
            z-index: -1;
            transition:
                opacity 0.3s ease,
                visibility 0s 0.3s,
                z-index 0s 0.3s;
            visibility: hidden;

            &.active {
                opacity: 1;
                pointer-events: all;
                visibility: visible;
                z-index: 1000;
                transition:
                    opacity 0.3s ease,
                    visibility 0s 0s,
                    z-index 0s 0s;
            }
        }

        &:hover {
            .recommended-container__tooltip-tablet-btn {
                &::before {
                    content: '';
                }
            }

            .recommended-container__tooltip-tablet-body {
                pointer-events: all;
                opacity: 1;
                visibility: visible;
                z-index: 1000;
                transition:
                    opacity 0.3s ease,
                    visibility 0s 0s,
                    z-index 0s 0s;
            }
        }
    }

    &__body {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 18px;
        flex-direction: column;

        @media only screen and (max-width: 1919px) {
            flex-direction: row;
            margin-bottom: 38px;
        }

        &.online-game {
            flex-direction: row;
            align-items: flex-start;
            margin-bottom: 35px;
            justify-content: space-between;

            @media only screen and (max-width: 1639px) {
                margin-bottom: 25px;
            }

            @media only screen and (max-width: 1439px) {
                margin-bottom: 45px;
            }

            @media only screen and (max-width: 1199px) {
                margin-bottom: 14px;
            }

            @media only screen and (max-width: 991px) {
                margin-bottom: 24px;
            }

            .recommended-container__body-info {
                margin-bottom: 0;
            }
        }

        &.game {
            @media only screen and (max-width: 1639px) {
                margin-bottom: 23px;
            }

            @media only screen and (max-width: 1439px) {
                margin-bottom: 30px;
            }

            @media only screen and (max-width: 1199px) {
                margin-bottom: 15px;
                max-height: 30px;
            }

            @media only screen and (max-width: 991px) {
                margin-bottom: 10px;
                max-height: 30px;
            }
        }

        &-info {
            width: 100%;
            display: flex;
            align-items: center;
            gap: 30px;
            margin-bottom: 24px;

            @media only screen and (max-width: 1919px) {
                width: unset;
                flex-direction: row;
                margin-bottom: 0;
                justify-content: space-between;

                .editon {
                    display: none !important;
                }
            }

            @media only screen and (max-width: 1639px) {
                gap: 0;
                justify-content: left;

                .editon {
                    display: block !important;
                }
            }

            @media only screen and (max-width: 991px) {
                .editon {
                    display: none !important;
                }
            }

            .online-info {
                display: flex;
                align-items: center;

                span {
                    font-family: "Avenir-Next", sans-serif;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 24px;
                    letter-spacing: 0px;
                    color: #9D9D9D;
                    border-left: 1px solid #E5E5E5;
                    padding-left: 10px;
                    margin-left: 10px;
                    white-space: nowrap;
                    max-width: 140px;
                    overflow: hidden;
                    -webkit-mask-image: linear-gradient(90deg, #fff 125px, transparent);

                    @media only screen and (max-width: 1199px) {
                        font-size: 14px;
                        line-height: 20px;
                    }

                    &:first-child {
                        border-left: none;
                        padding-left: 0;
                        margin-left: 0;
                    }

                    .placeholder {
                        width: 45px;
                        height: 24px;
                        display: flex;
                    }
                }
            }

            .flex-row {
                width: 328px;

                &.online-game {
                    width: 313px;
                }

                .flex-column {
                    gap: 10px;
                    min-width: 140px;
                }
            }

            .text {
                display: block;
                width: 155px;
                height: 12px;
                border-radius: 11px;
            }

            .line {
                display: block;
                width: 1px;
                height: 30px;
                background: #E5E5E5;
                margin: 0 15px;
                min-width: 1px;
            }

            .info-text {
                font-family: "Avenir-Next", sans-serif;
                font-weight: 400;
                font-size: 14px;
                line-height: 140%;
                letter-spacing: 0px;
                color: #9D9D9D;
                padding-right: 5px;
            }

            .info-value {
                font-family: "Avenir-Next", sans-serif;
                font-weight: 400;
                font-size: 14px;
                line-height: 140%;
                letter-spacing: 0px;
                color: #505050;
            }
        }

        &-tooltip {
            width: 100%;
            display: flex;
            justify-content: space-between;

            @media only screen and (max-width: 1919px) {
                &.game {
                    border-left: 1px solid #E5E5E5;
                    padding-left: 15px;
                    margin-left: 15px;
                }

                &.online-game {
                    width: auto;
                }
            }

            @media only screen and (max-width: 1639px) {
                // &.game{
                //     padding-left: 0;
                //     margin-left: 0;
                //     width: auto;
                // }
            }

            @media only screen and (max-width: 1439px) {
                .region-info {
                    display: block;
                }

                &.game {
                    width: 100%;
                    border-left: 1px solid #E5E5E5;
                    padding-left: 15px;
                    margin-left: 15px;
                }
            }

            @media only screen and (max-width: 991px) {
                &.game {
                    border-left: none;
                    padding-left: 0;
                    margin-left: 0;
                }
            }

            &.game {
                .region-row {
                    width: 100%;
                    display: flex;
                    gap: 30px;

                    .region-column {
                        width: 50%;
                        display: flex;
                        align-items: center;
                        gap: 20px;

                        &.w-100 {
                            width: 100%;
                        }
                    }
                }
            }
        }
    }

    &__price {
        &-title {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 10px;

            @media only screen and (max-width: 1919px) {
                margin-bottom: 14px;
            }

            @media only screen and (max-width: 1199px) {
                margin-bottom: 10px;
            }

            &-line {
                display: block;
                width: 100%;
                height: 1px;
                background: #E5E5E5;
            }

            &-text {
                font-family: "Avenir-Next", sans-serif;
                font-weight: 400;
                font-size: 12px;
                line-height: 120%;
                letter-spacing: 0px;
                color: #C9C9C9;
                white-space: nowrap;
            }
        }

        &-amount {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;

            @media only screen and (max-width: 1919px) {
                margin-bottom: 20px;

                &.online-game {
                    margin-bottom: 5px;
                }
            }

            @media only screen and (max-width: 1199px) {
                margin-bottom: 10px;
            }

            &-title {
                font-family: "Avenir-Next", sans-serif;
                font-weight: 400;
                font-size: 18px;
                line-height: 24px;
                letter-spacing: 0px;
                color: #9D9D9D;
                white-space: nowrap;

                &.placeholder {
                    width: 100px;
                    height: 24px;

                    @media only screen and (min-width: 1920px) {
                        height: 30px;
                    }
                }

                @media only screen and (max-width: 1919px) {
                    font-size: 16px;

                    &.online-game {
                        font-size: 14px;
                        line-height: 20px;
                    }
                }

                @media only screen and (max-width: 1199px) {
                    &.online-game {
                        font-size: 12px;
                        line-height: 120%;
                    }

                    &.game.discount-offer {
                        display: none;
                    }
                }
            }

            &-value {
                display: flex;
                gap: 10px;
                align-items: center;
                font-family: "Avenir-Next-DemiBold", sans-serif;
                font-weight: 600;
                font-size: 28px;
                line-height: 140%;
                letter-spacing: 0px;
                color: #11151A;
                white-space: nowrap;

                @media only screen and (max-width: 1919px) {
                    font-size: 22px;

                    &.online-game {
                        font-size: 16px;
                    }
                }

                @media only screen and (max-width: 1199px) {
                    &.online-game {
                        font-size: 12px;
                    }

                    &.game.discount-offer {
                        width: 100%;
                    }
                }

                &.discount-offer {
                    justify-content: flex-end;
                    min-width: 0;

                    .discount-offer__old-price {
                        @media only screen and (max-width: 1024px) {
                            display: none;
                        }
                    }

                    .discount-offer__percent {
                        display: flex;
                        align-items: center;
                        transition: 0.4s;
                        max-width: 45px;
                        height: 22px;
                        width: 100%;

                        &-code {
                            transition: 0.4s;
                            display: flex;
                            align-items: center;
                            overflow: hidden;
                            max-width: 100%;
                            padding: 0 5px;

                            img {
                                padding-left: 5px;
                            }
                        }
                    }

                    &:hover {
                        @media only screen and (min-width: 1024px) {
                            // .discount-offer__percent{
                            //     max-width: 100%;
                            // }
                            // .discount-offer__percent-code{
                            //     max-width: 100%;
                            //     padding: 0 5px;
                            // }
                            // .discount-offer__old-price{
                            //     width: 0;
                            //     overflow: hidden;
                            // }

                        }
                    }
                }

                &.placeholder {
                    width: 132px;
                    height: 30px;
                    border-radius: 11px;

                    @media only screen and (min-width: 1920px) {
                        height: 40px;
                    }

                    @media only screen and (max-width: 991px) {
                        display: none;
                    }
                }
            }

            &.stock {
                margin-bottom: 20px;

                @media only screen and (max-width: 1199px) {
                    margin-bottom: 10px;
                }

                .recommended-container__price-amount-title {
                    font-size: 22px;

                    @media only screen and (max-width: 1919px) {
                        font-size: 18px;
                    }

                    @media only screen and (max-width: 1199px) {
                        font-size: 16px;
                    }
                }

                .recommended-container__price-amount-value {
                    font-size: 32px;

                    @media only screen and (max-width: 1919px) {
                        font-size: 24px;
                    }

                    @media only screen and (max-width: 1199px) {
                        font-size: 22px;
                    }
                }
            }
        }

        &-btn {
            display: flex;
            gap: 15px;

            .btn {
                width: 100%;
                height: 54px;
                border-radius: 8px;
                background-color: #fff;
                border: 1px solid #F75A01;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
                transition: 0.4s;

                @media only screen and (max-width: 1919px) {
                    height: 46px;
                }

                @media only screen and (max-width: 991px) {
                    height: 20px;
                }

                span {
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-weight: 400;
                    font-size: 14px;
                    leading-trim: NONE;
                    line-height: 140%;
                    letter-spacing: 0px;
                    text-align: center;
                    color: #F75A01;
                    transition: 0.4s;
                }

                svg path {
                    transition: 0.4s;
                }

                &.preload {
                    position: relative;

                    svg {
                        opacity: 0;
                    }

                    span {
                        opacity: 0;
                    }

                    &::before {
                        content: "";
                        position: absolute;
                        right: 44%;
                        top: 24%;
                        -webkit-transform: translate(-50%, -50%);
                        -ms-transform: translate(-50%, -50%);
                        -moz-transform: translate(-50%, -50%);
                        transform: translate(-50%, -50%);
                        width: 21px;
                        height: 21px;
                        background: url("/webpack-assets/img/icons/gray-prelodader.svg") center center no-repeat;
                        background-size: 100%;
                        animation: rot 1s infinite linear;
                    }

                    &.online {
                        &::before {
                            right: 50%;
                        }
                    }
                }

                &:hover {
                    border: 1px solid #FF843F;

                    svg path,
                    span {
                        color: #FF843F;
                        fill: #FF843F;
                    }
                }

                &__add-to-card {
                    &.online {
                        background-color: #F75A01;

                        svg path,
                        span {
                            color: #F6F6F6;
                            fill: #F6F6F6;
                        }

                        &:hover {
                            background-color: #FF843F;

                            svg path,
                            span {
                                color: #F6F6F6;
                                fill: #F6F6F6;
                            }
                        }

                        &.remove {
                            background-color: #fff;
                            border-color: #F43232;

                            svg path,
                            span {
                                color: #F43232;
                                fill: #F43232;
                            }

                            &:hover {
                                border-color: #C32828;

                                svg path,
                                span {
                                    color: #C32828;
                                    fill: #C32828;
                                }
                            }
                        }
                    }

                    &.remove {
                        border-color: #F43232;

                        span {
                            color: #F43232;
                        }

                        &:hover {
                            border-color: #C32828;

                            svg path,
                            span {
                                color: #C32828;
                                fill: #C32828;
                            }
                        }
                    }

                }

                &__go-cheсkout {
                    background-color: #F75A01;

                    span {
                        color: #f6f6f6;
                    }

                    &:hover {
                        background-color: #FF843F;

                        svg path,
                        span {
                            color: #f6f6f6;
                            fill: #f6f6f6;
                        }
                    }
                }

                &.placeholder {
                    border: none;
                }
            }
        }

        &-tablet {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .line {
                height: 32px;
                width: 1px;
                background-color: #E5E5E5;
                margin: 0 12px;
            }

            &-price {
                font-size: 16px;
            }

            .recommended-container__price-amount {
                flex-direction: column;
                margin-bottom: 0;

                &-title {
                    font-family: "Avenir-Next", sans-serif;
                    font-weight: 400;
                    font-size: 12px !important;
                    line-height: 120%;
                    letter-spacing: 0px;
                    vertical-align: middle;
                    color: #9D9D9D;
                }

                &-value {
                    font-family: "Avenir-Next", sans-serif;
                    font-weight: 400;
                    font-size: 16px !important;
                    line-height: 24px;
                    letter-spacing: 0px;
                    color: #505050;
                }
            }

            .btn {
                width: 32px;
                height: 32px;
                border-radius: 7px;
                min-width: 32px;
                padding: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                &__add-to-cart {
                    background-color: #4E8AFF;
                }

                &__remove-from-cart {
                    background-color: #F43232;
                }

                svg {
                    width: 20px;
                    height: 20px;
                }

                .placeholder {
                    width: 32px;
                    height: 32px;
                    border-radius: 8px;
                }
            }
        }
    }
}
</style>